/**
 * InspectionIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const InspectionIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8.11 14.29a1 1 0 0 1 1.41 0l1.42 1.42 3.54-3.54a1 1 0 1 1 1.41 1.42l-4.24 4.24a1 1 0 0 1-1.42 0l-2.12-2.12a1 1 0 0 1 0-1.42" />
    <path
      fillRule="evenodd"
      d="M18 4h1a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 2 0v1h8V3a1 1 0 1 1 2 0zm1 16a1 1 0 0 0 1-1v-9H4v9a1 1 0 0 0 1 1zM4 8h16V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const InspectionIcon = makeIcon('InspectionIcon', InspectionIconSvg)
